module.exports = __webpack_public_path__ + "media/blog/instagram-696b2e33.png";